export enum LogoOrientation {
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical'
}